module.exports = __webpack_public_path__ + "img/IMG_0377.03a8bd5e.jpg";